import { WSTableCell } from "@wingspanhq/fe-component-library";
import { Stakeholder } from "@wingspanhq/wingspan-api-sdk";
import * as React from "react";
import { selectorPersonDisplayName } from "../../../../shared/selectors/selectorPersonDisplayName";
import { useStakeholderPerson } from "./useStakeholderPerson";

type Props = {
  stakeholder: Stakeholder;
};

export const StakeholderNameCell: React.FC<Props> = props => {
  const queryPerson = useStakeholderPerson(props.stakeholder);
  const person = queryPerson.data;

  const email = person?.email || props.stakeholder.email || "";
  const name = person ? selectorPersonDisplayName(person) : email;
  const displayName = name || email;

  return (
    <WSTableCell
      avatar={{
        type: "text",
        text: displayName,
        color: "gray600",
        colorBackground: "gray200"
      }}
      text={displayName}
      secondaryText={email && email !== displayName ? email : undefined}
      truncationOptions={{
        text: {
          allowTwoLines: true
        }
      }}
    />
  );
};
